// src/components/NavigationBar/NavigationBar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDarkMode } from '../DarkMode';
import './NavigationBar.css';

const NavigationBar = ({ links }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <span className="text-xl">Christian Ansel</span>
        </div>
        <div className="md:hidden">
          <button onClick={toggleMenu} className="focus:outline-none">
            <svg
              className="h-6 w-6 fill-current"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm16 5H4a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2zm0 4H4a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2z"
              />
            </svg>
          </button>
        </div>
        <div className="hidden md:block">
          <ul className="flex space-x-4">
            {links.map((link, index) => (
              <li key={index}>
                <Link to={link.to} className="text">{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        {/* Dark Mode Toggle Button */}
        <div>
          <button className={`text-white px-6 py-2 rounded relative ${isDarkMode ? 'bg-gray-600' : 'bg-gray-100'}`} onClick={toggleDarkMode}>
            {isDarkMode ? (
              <>
                <span className='text-white flex items-center'> 
                  <img src="https://static.xx.fbcdn.net/images/emoji.php/v9/te5/1/32/1f311.png" alt="moon" />
                  Dark Mode
                </span>
              </>
            ) : (
              <>
                <span className='text-black flex items-center'>
                  <img src="https://static.xx.fbcdn.net/images/emoji.php/v9/t73/1/32/2600.png" alt="sun" />
                  Light Mode
                </span>
              </>
            )}
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden">
          <ul className="mt-2">
            {links.map((link, index) => (
              <li key={index}>
                <Link to={link.to} className="text">{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default NavigationBar;
